import axios from "axios";
const API_URL = "/api/ace-routing/";

// #21 — fetch the read-only ACE routing rules (Applied GA admin only).
const list = async () => {
  const response = await axios.get(API_URL);
  return response.data;
};

const aceRoutingService = { list };

export default aceRoutingService;
